import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import I18n from 'utils/I18n';

import ActivityDistanceNormalXsmall from '@strava/icons/ActivityDistanceNormalXsmall';
import Button from '@strava/ui/Button';
import styles from './index.scss';
import useFeedAnalytics from '../../../hooks/useFeedAnalytics';
import useFeedRitmoCapping from '../../../hooks/useFeedRitmoCapping';
import { useFeedEntityContext } from '../FeedEntityContext';
import useFeedIntersectionObserver from '../../../hooks/useFeedIntersectionObserver';

function MapVisPrompt({ hideAnywhereSetting, paths, entityId }) {
  const units = I18n.measurementUnits();
  const i18nPrefix = `components.feed.map_vis_prompt.${hideAnywhereSetting}.`;
  const { analyticProps } = useFeedEntityContext();

  const { inView, intersectionObserverRef } = useFeedIntersectionObserver({
    isParentFeedEntry: false
  });

  const { updateRitmo } = useFeedRitmoCapping();

  const analyticsProperties = {
    cta: 'hide_start_end_opt_out',
    hide_anywhere: hideAnywhereSetting
  };
  const { trackAnalytics } = useFeedAnalytics({
    ...analyticProps,
    inView,
    element: 'map_visibility_activity_row_prompt',
    properties: analyticsProperties
  });

  useEffect(() => {
    updateRitmo({
      elementId: entityId,
      path: paths.promptImpression,
      promo: 'map_visibility_row_reinforcement_impression',
      inView
    });
  }, [entityId, inView, paths.promptImpression, updateRitmo]);

  const onButtonClick = () => {
    trackAnalytics({
      action: 'click',
      element: 'map_visibility_activity_row_prompt'
    });

    updateRitmo({
      path: paths.promptImpression,
      promo: 'map_visibility_row_reinforcement_dismissed',
      elementId: entityId
    });
    window.location.href = paths.hideAnywhere;
  };

  return (
    <div className={styles.mapVisPrompt} data-testid="map_vis_prompt_container">
      <div>
        <ActivityDistanceNormalXsmall />
      </div>
      <div
        className={styles.description}
        data-testid="map_vis_prompt_description"
        ref={intersectionObserverRef}
      >
        {hideAnywhereSetting === 'meters_200'
          ? I18n.t(`${i18nPrefix}description_${units}`)
          : I18n.t(`${i18nPrefix}description`)}
      </div>
      <Button
        className={styles.button}
        variant="primary-outline"
        onClick={onButtonClick}
        data-testid="map_vis_prompt_button"
      >
        {I18n.t(`${i18nPrefix}button`)}
      </Button>
    </div>
  );
}

MapVisPrompt.propTypes = {
  hideAnywhereSetting: PropTypes.string.isRequired,
  paths: PropTypes.shape({
    promptImpression: PropTypes.string,
    hideAnywhere: PropTypes.string
  }).isRequired,
  entityId: PropTypes.string.isRequired
};

export default MapVisPrompt;
